export default __webpack_public_path__ + "static/Secure-payments-3d5717fdb53bc17483a2fe01efc4ecc2.webp";